import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './app.unauthorized.component.html',
  styleUrls: ['./app.unauthorized.component.scss'],

  standalone: false,})
export class AppUnauthorizedComponent {
  title: string = 'SBVP';

  constructor() {
    this.title = environment.applicationTitle;
  }
}
